(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-wishlist-page"]) return;
  try {
    
  class WishlistView extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.gridViewContainer = this.querySelector('[data-wishlist-items-grid-display]');
      this.wishlistPaginateContainer = document.getElementById('wishlist-paginate');
      this.viewCols = [...this.querySelectorAll('[data-col]')];

      this.wishlistContainer = this.closest('[data-wishlist-container]');
      this.wishlistFooter = document.querySelector('[data-wishlist-footer]');

      this.viewCols.forEach(viewCol => {
        viewCol.addEventListener('click', this.onViewColClick.bind(this));
      });

      window.addEventListener('resize', theme.utils.rafThrottle(this.onResize.bind(this)));

      this.initWishlistPage();
    }

    getMaxColOnSize() {
      const availableViewCols = this.viewCols.filter(view => {
        return getComputedStyle(view, null).getPropertyValue('display') === 'inline-block';
      }).map(view => Number(view.dataset.col));

      return availableViewCols[availableViewCols.length - 1];
    }

    onResize() {
      const selectedColEl = this.querySelector('[data-col].active');
      if (!selectedColEl) return;
      const selectedCol = Number(selectedColEl.dataset.col);
      const maxColNum = this.getMaxColOnSize();

      if (selectedCol > maxColNum) {
        const target = this.viewCols.find(viewCol => Number(viewCol.dataset.col) === maxColNum);
        if (target) target.click();
      }
    }

    onViewColClick(event) {
      const viewCol = event.target;
      const col = Number(viewCol.dataset.col);

      this.switchViewListGrid(col === 1);
      this.setPaginationAndHeadingView(col === 1);
      this.paginationForList(col === 1);
      this.setGridColumns(col);
      this.setActiveViewCol(viewCol);
    }

    switchViewListGrid(isList) {
      if (isList) {
        this.gridViewContainer.classList.add('productList');
        return;
      }

      this.gridViewContainer.classList.remove('productList');
    }

    setGridColumns(col) {
      this.gridViewContainer.style.setProperty('--grid-columns', col);
    }

    setActiveViewCol(colElement) {
      this.viewCols.forEach(col => col.classList.remove('active'));
      colElement.classList.add('active');
    }

    setPaginationAndHeadingView(isList) {
      if (isList) {
        this.wishlistPaginateContainer.style.display = 'flex';
        return;
      }

      this.wishlistPaginateContainer.style.display = 'none';
    }

    paginationForList(isList) {
      const items = this.gridViewContainer.querySelectorAll('.product');
      const currentPage = Number(this.wishlistPaginateContainer.dataset.currentPage);

      if (isList && currentPage) {
        items.forEach((item, index) => {
          if (index >= (currentPage - 1) * 3 && index < currentPage * 3) {
            item.style.display = '';
          } else {
            item.style.display = 'none';
          }
        });
      } else {
        items.forEach((item) => {
          item.style.display = '';
        });
      }
    }

    async initWishlistPage() {
      if (typeof(Storage) !== 'undefined') {
        const wishlistList = localStorage.getItem('wishlistItem') ? JSON.parse(localStorage.getItem('wishlistItem')) : [];

        if (wishlistList.length > 0) {
          try {
            await Promise.all(wishlistList.map((handle, index) => this.setProductForWishlistPage(handle, index, wishlistList.length)));
            this.gridViewContainer.classList.add('is-loaded');
            this.wishlistPagination();
            this.setDefaultLayout();
            this.updateShareWishlistViaMail();
            document.addEventListener('update:pagination', this.wishlistPagination.bind(this));
            document.addEventListener('add:wishlist-item', async (event) => {
              const handle = event.detail.handle;
              await this.setProductForWishlistPage(handle);
            });
            document.addEventListener('remove:wishlist-item', (event) => {
              const handle = event.detail?.handle;
              const productId = event.detail?.productId;
              this.removeItemFromWishlistPage(handle, productId);
            });
          } catch(err) {
            console.error(err);
          }
        } else {
          if (this.wishlistContainer) {
            this.wishlistContainer.classList.add('is-empty');
            this.wishlistContainer.innerHTML = `
              <div class="page-margin wishlist-content-empty center">
                <span class="wishlist-content-text block">${window.wishlist.empty}</span>
                <div class="wishlist-content-actions">
  <a class="button" href="https://tapron.co.uk/">
    ${window.wishlist.continue_shopping}
  </a>
</div>
              </div>
            `;
          }

          if (this.wishlistFooter) this.wishlistFooter.style.display = 'none';
        }
      } else {
        alert('Sorry! No web storage support..');
      }
    }

    setDefaultLayout() {
      const defaultDesktopCol = parseInt(this.dataset.defaultDesktopCol);
      const maxCol = this.getMaxColOnSize();
      const defaultCol = (defaultDesktopCol <= maxCol) ? defaultDesktopCol : maxCol;

      const targetViewCol = this.viewCols.find(viewCol => parseInt(viewCol.dataset.col) === defaultCol );
      if (targetViewCol) {
        targetViewCol.click();
      }
    }

    async setProductForWishlistPage(handle, index, wishlistListLength) {
      try {

        const res = await fetch(`${window.routes.shop_origin}/products/${handle}?view=block_wishlist_card`);
        const data = await res.text();
        const parser = new DOMParser();

        const parsedDoc = parser.parseFromString(data, 'text/html');
        const productHTML = parsedDoc.querySelectorAll('#MainContent .card--block')[0];

        this.gridViewContainer.appendChild(productHTML);
        productHTML.dataset.productHandle = handle;

        this.updateProductForWishlistPage();

        const item = this.wishlistContainer.querySelector(`.card--block[data-product-handle="${handle}"]`);

        if (item != null) {
          item.classList.add('wishlist-added');
          item.querySelector('.text').textContent = window.wishlist.remove;
          item.classList.add('is-in-grid');
          productHTML.dataset.wishlistAdded = `wishlist-${item.dataset.productId}`;
        }

      } catch (err) {
        console.error(err);
      }
    }

    updateProductForWishlistPage() {
      const sectionFetcher = document.querySelector('section-fetcher');

      if (sectionFetcher && typeof sectionFetcher.initialize === 'function') {
        sectionFetcher.initialize();
      } else {
        console.error('WishlistView: No section fetcher component found or initialize method not available');
      }
    }

    wishlistPagination() {
      const wishlistList = localStorage.getItem('wishlistItem') ? JSON.parse(localStorage.getItem('wishlistItem')) : [];

      this.wishlistPaginateContainer.setAttribute('data-current-page', 1);
      while (this.wishlistPaginateContainer.firstChild) {
        this.wishlistPaginateContainer.removeChild(this.wishlistPaginateContainer.firstChild);
      }

      if (!this.gridViewContainer.classList.contains('productList')) return;
      this.gridViewContainer.classList.remove('is-loaded');

      this.totalPages = Math.ceil(wishlistList.filter(item => item != null).length / 3);

      if (this.totalPages <= 1) {
        [...this.gridViewContainer.children].forEach(child => {
          child.style.display = 'block';
        });
        this.gridViewContainer.classList.add('is-loaded');
        return;
      }

      this.gridViewContainer.classList.add('is-loaded');
    }

    removeItemFromWishlistPage(handle, productId) {
      let productElement = null;

      if (handle) {
        productElement = this.gridViewContainer.querySelector(`[data-product-handle="${handle}"]`);
      }

      if (!productElement && productId) {
        productElement = this.gridViewContainer.querySelector(`[data-wishlist-added="wishlist-${productId}"]`);
      }

      if (productElement) {
        productElement.remove();
      }

      const wishlistList = localStorage.getItem('wishlistItem') ? JSON.parse(localStorage.getItem('wishlistItem')) : [];
      const remainingItems = this.gridViewContainer.querySelectorAll('[data-product-handle]');

      if (wishlistList.length === 0 || remainingItems.length === 0) {
        if (this.wishlistContainer) {
          this.wishlistContainer.classList.add('is-empty');
          this.wishlistContainer.innerHTML = `
            <div class="page-margin wishlist-content-empty center">
              <span class="wishlist-content-text block">${window.wishlist.empty}</span>
              <div class="wishlist-content-actions">
  <a class="button" href="https://tapron.co.uk/">
    ${window.wishlist.continue_shopping}
  </a>
</div>
            </div>
          `;
        }

        if (this.wishlistFooter) {
          this.wishlistFooter.style.display = 'none';
        }
      } else {
        this.wishlistPagination();
        const updateWishlistMailEvent = new CustomEvent('update:wishlist-mail', {
          bubbles: true
        });
        document.dispatchEvent(updateWishlistMailEvent);

        if (this.gridViewContainer.classList.contains('productList')) {
          const currentPage = Number(this.wishlistPaginateContainer.dataset.currentPage) || 1;
          this.paginationForList(true);
        }
        this.updateShareWishlistViaMail();
      }
    }

    paginateToPages(nextPageNumber = null) {
      const children = [...this.gridViewContainer.children];

      if (nextPageNumber == null) {
        children.forEach((element, index) => {
          if (index >= 3) {
            element.style.display = 'none';
          }
          else {
            element.style.display = 'block';
          }
        });
        return;
      }

      children.forEach((element, index) => {
        if (index >= (nextPageNumber - 1) * 3 && index < nextPageNumber * 3) {
          element.style.display = 'block';
        }
        else {
          element.style.display = 'none';
        }
      });

      if (nextPageNumber === 1) {
        this.wishlistPaginateContainer.querySelector('.prev').classList.add('disabled');
        this.wishlistPaginateContainer.querySelector('.next').classList.remove('disabled');
      }
      else if (nextPageNumber === this.totalPages) {
        this.wishlistPaginateContainer.querySelector('.next').classList.add('disabled');
        this.wishlistPaginateContainer.querySelector('.prev').classList.remove('disabled');
      }
      else {
        this.wishlistPaginateContainer.querySelector('.prev').classList.remove('disabled');
        this.wishlistPaginateContainer.querySelector('.next').classList.remove('disabled');
      }
    }

    removeAndAddPaginationButtonEvents() {
      const container = this.wishlistPaginateContainer;
      const newContainer = container.cloneNode(true);
      container.parentNode.replaceChild(newContainer, container);
      this.wishlistPaginateContainer = newContainer;

      this.wishlistPaginateContainer.addEventListener('click', (event) => {
        const link = event.target.closest('li a');
        if (!link) return;

        event.preventDefault();
        const li = link.parentElement;
        const isPrev = li.classList.contains('prev');
        const isNext = li.classList.contains('next');
        let pageNumber = parseInt(link.dataset.page);

        const currentButton = this.wishlistPaginateContainer.querySelector('.active');
        let curPage = currentButton ? parseInt(currentButton.querySelector('.link').dataset.page) : 1;

        if (isPrev) {
          pageNumber = curPage - 1;
          if (pageNumber <= 0) pageNumber = 1;
        }

        if (isNext) {
          pageNumber = curPage + 1;
          if (pageNumber > this.totalPages) pageNumber = this.totalPages;
        }

        this.wishlistPaginateContainer.dataset.currentPage = pageNumber;
        this.paginateToPages(pageNumber);

        if (currentButton) {
          currentButton.classList.remove('active');
        }
        const newActive = this.wishlistPaginateContainer.querySelector(`[data-page="${pageNumber}"]`);
        if (newActive && newActive.parentElement) {
          newActive.parentElement.classList.add('active');
        }
      });
    }


    updateShareWishlistViaMail() {
      const regex = /[\n\r\s]+/g;
      const addedItems = this.gridViewContainer.querySelectorAll('[data-wishlist-added].product-card-wrapper');
      if (!this.wishlistFooter) return;
      const shareLinkElement = this.wishlistFooter.querySelector('[data-wishlist-share]');
      
      if (!shareLinkElement) return;

      let href = 'mailto:?subject=My Wish List&body=Here is my wishlist:%0A%0A';

      addedItems.forEach((item) => {
        const titleEl = item.querySelector('.card__heading');
        const title = titleEl ? titleEl.innerText.trim() : 'Product';
        const priceEl = item.querySelector('.price-item--sale') || item.querySelector('.price-item--regular');
        const price = priceEl ? priceEl.innerText.trim().replace(regex, ' ') : '';

        const url = item.querySelector('[data-product-url]')?.dataset.productUrl;

        href += encodeURIComponent(title + '\nPrice: ' + price?.replace(regex, '') + '\nLink: ' + window.location.protocol + '//' + window.location.hostname + url +'\n\n----------------\n\n');
      });

      shareLinkElement.href = href;
    }


  }
  if (!customElements.get('wishlist-view')) customElements.define('wishlist-view', WishlistView);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const tabTitles = document.querySelectorAll('.tab-title');
    const tabContents = document.querySelectorAll('.tab-content');

    function removeExtraTableSigns(scope = document) {
      const contents = scope.querySelectorAll('.toggle-content');

      contents.forEach(content => {
        content.childNodes.forEach(node => {
          if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() === '>') {
            const next = node.nextSibling;
            if (next && next.nodeType === Node.ELEMENT_NODE && next.tagName === 'TABLE') {
              node.remove();
            }
          }
        });
      });
    }

    removeExtraTableSigns();

    if (tabTitles.length && tabContents.length && tabTitles.length === tabContents.length) {
      tabTitles.forEach((title, i) => {
        title.addEventListener('click', function (e) {
          e.preventDefault();
          if (title.classList.contains('is-active')) return;
          tabTitles.forEach(t => t.classList.remove('is-active'));
          tabContents.forEach(c => c.classList.remove('is-active'));
          title.classList.add('is-active');
          setTimeout(() => {
            const content = tabContents[i];
            content.classList.add('is-animating');
            content.classList.add('is-active');
            content.addEventListener('transitionend', function handler() {
              content.classList.remove('is-animating');
              content.removeEventListener('transitionend', handler);
            });
          }, 10);
        });
      });
    }

    const toggleLinks = document.querySelectorAll('.toggle-link');

    toggleLinks.forEach(toggleLink => {
      toggleLink.addEventListener('click', function(e) {
        e.preventDefault();

        const toggleTitle = toggleLink.closest('.toggle-title');
        if (!toggleTitle) return;

        const tabTitleText = document.querySelector('.tab-title-text');
        if (tabTitleText) {
          tabTitleText.textContent = toggleLink.textContent;
        }

        const viewContentType = toggleTitle.dataset.viewContent;
        const content = toggleTitle.nextElementSibling;
        if (!content) return;

        switch (viewContentType) {
          case 'sidebar': {
            const drawerContent = document.querySelector('#Global-Drawer .drawer__wrapper');
            if (drawerContent) {
              drawerContent.innerHTML = '';
              drawerContent.appendChild(content.cloneNode(true));
              removeExtraTableSigns(drawerContent);
              renderVideo();
            }
            break;
          }
          case 'popup': {
            const popupContent = document.querySelector('.popup-content-wrapper');
            if (popupContent) {
              popupContent.innerHTML = '';
              popupContent.appendChild(content.cloneNode(true));
              removeExtraTableSigns(popupContent);
              renderVideo();
            }
            break;
          }
          default:
            toggleTitle.classList.toggle('is-open');
        }
      });
    });
    const modalTemplate = `
      <side-drawer
        class="popup__content video-modal drawer fixed top-0 left-0 z-9 w-screen h-full flex justify-center no-js-hidden"
        element-s-popup=""
        id="PopupModal-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
        data-moved="true"
      >
        <div
          id="Drawer-Overlay-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
          class="drawer__overlay fixed inset-0 cursor-pointer"
          style="transform: translateX(0px)"
        ></div>
        <div
          class="popup__inner color-scheme-1 popup__inner--video w-auto h-full absolute-c-c flex flex-column global-settings-popup"
        >
          <div
            class="popup__inner--content relative w-full h-full overflow-auto cus-scrollbar"
          >
            <div class="video-modal__content-block">Video</div>
            <button
              onclick="this.closest('side-drawer').close()"
              class="button button-unstyled close-button popup__close minimum-touch-target-before drawer__close block t-button bor-none rounded-full cursor-pointer absolute"
              type="button"
              aria-label="Close dialog"
              style="--top: 0.3rem; --right: 0.3rem"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                class="icon icon-close"
                viewBox="0 0 18 17"
              >
                <path
                  fill="currentColor"
                  d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      </side-drawer>
    `;
    document.body.insertAdjacentHTML('beforeend', modalTemplate);

    function renderVideo() {
      const videoOpenPopups = document.querySelectorAll('.video-open-popup');

      if (videoOpenPopups.length > 0) {
        videoOpenPopups.forEach(videoOpenPopup => {
          videoOpenPopup.addEventListener('click', function(e) {
            e.preventDefault();

            const videoId = videoOpenPopup.dataset.videoId;
            const videoWrapper = document.querySelector('.video-modal__content-block');

            const youtubeIframe = `
            <iframe width="100%" src="https://www.youtube.com/embed/${videoId}?si=6yJ56P_BJEG5d2Uq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            `;

            videoWrapper.innerHTML = youtubeIframe;
          });
        });
      }
    }
    renderVideo();
  });

  } catch(e) { console.error(e); }
})();
})();
